const translation = {
  title: '探索',
  sidebar: {
    discovery: '探索',
    chat: 'チャット',
    workspace: 'ワークスペース',
    action: {
      pin: 'ピン留め',
      unpin: 'ピン留め解除',
      rename: '名前変更',
      delete: '削除',
    },
    delete: {
      title: 'アプリを削除',
      content: 'このアプリを削除してもよろしいですか？',
    },
  },
  apps: {
    title: 'アプリを探索',
    description: 'これらのテンプレートアプリを即座に使用するか、テンプレートに基づいて独自のアプリをカスタマイズしてください。',
    allCategories: '推奨',
  },
  appCard: {
    addToWorkspace: 'ワークスペースに追加',
    customize: 'カスタマイズ',
  },
  appCustomize: {
    title: '{{name}}からアプリを作成',
    subTitle: 'アプリアイコンと名前',
    nameRequired: 'アプリ名は必須です',
  },
  category: {
    Assistant: 'アシスタント',
    Writing: '執筆',
    Translate: '翻訳',
    Programming: 'プログラミング',
    HR: '人事',
    Workflow: 'ワークフロー',
    Agent: 'エージェント',
    Entertainment: 'エンターテイメント',
  },
}

export default translation
